import Head from "next/head";
import { make as UnitInfoPage } from "../../../../src/info/UnitInfoPage.bs";
import { units as unitsT } from "common/src/bindings/Translation2.ts";
import { fromUrlName } from "common/src/tft-static/Sd.ts";

export default function UnitsInfo({ unitId, topItems }) {
  return (
    <>
      <Head>
        <title>{`${unitsT(unitId)} Set 4.5 TFT Info & Best Item Build`}</title>
      </Head>
      <UnitInfoPage set={46} unitId={unitId} topItems={topItems} />
    </>
  );
}

export function getStaticPaths() {
  return { paths: [], fallback: "blocking" };
}

export async function getStaticProps({ params }) {
  const { unitName } = params;
  const unitId = fromUrlName(unitName, 46);
  if (unitId == null) {
    return {
      notFound: true,
    };
  }

  let topItems = [];

  return {
    props: {
      unitId,
      topItems,
    },
  };
}
